/* eslint-disable no-console */
import { WrapModal } from './styles';

import ButtonTooltip from '../../ButtonTooltip';

import checkMosaicSCCON from 'views/MapView/services/utils/checkMosaicSCCON';

import Icon from '@map/components/Icons';
import { CircularProgress } from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import CustomDraggable from 'components/ModalDraggable';
import { useEffect, useState } from 'react';
import { useMap, useModule } from 'views/MapView/hooks';

export const ChangeMosaic = ({ mapContext, isActive, setIsActive, ...props }) => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const currentDate = new Date();
  const previousMonth = currentDate.getMonth() === 0 ? 12 : currentDate.getMonth();
  const previousYear = currentDate.getMonth() === 0 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(String(previousMonth).padStart(2, '0'));
  const [selectedYear, setSelectedYear] = useState(previousYear);
  const [limitYear, setLimitYear] = useState(null);
  const [limitMonth, setLimitMonth] = useState(null);
  const [baseMapSCCON, setBaseMapSCCON] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { changeBaseMapDinamic, changeAttributionDinamic } = useMap();
  const { activeModule } = useModule();
  const minYear = 2017;
  const maxYear = new Date().getFullYear();
  const [count, setCount] = useState(0);
  const dateAttribution = `${selectedMonth}/${selectedYear}`;

  const months = [
    { number: '01', name: 'Jan' },
    { number: '02', name: 'Fev' },
    { number: '03', name: 'Mar' },
    { number: '04', name: 'Abr' },
    { number: '05', name: 'Mai' },
    { number: '06', name: 'Jun' },
    { number: '07', name: 'Jul' },
    { number: '08', name: 'Ago' },
    { number: '09', name: 'Set' },
    { number: '10', name: 'Out' },
    { number: '11', name: 'Nov' },
    { number: '12', name: 'Dez' },
  ];

  // Usado para ter referencia global, ex: na impresão de mapa
  localStorage.setItem('mapPlanet', `${selectedMonth}/${selectedYear}`);

  /**
   * Monta link para buscar dados no padrao da api da SCCON
   * @param {*} link Link padrao do mapa base da sccon
   * @param {*} side Lado de referencia
   * @param {*} month Mes de referencia
  */
  const updateLink = (link, year, month) => {
    return link.replace(
      /global_monthly_\d{4}_\d{2}_mosaic/,
      `global_monthly_${year}_${month}_mosaic`
    );
  };

  /**
   * Função que escuta mudança de mes/ano no componente
   * @param {*} month Mes de referencia
  */
  const handleMonthClick = (month) => {
    setSelectedMonth(month);
    setSelectedYear(currentYear);
    changeBaseMapDinamic(baseMapSCCON.id, updateLink(baseMapSCCON.link, currentYear, month));
    setCount((prevCount) => prevCount + 1);
  };

  /**
   * Aumenta Ano
  */
  const incrementYear = () => {
    if (currentYear < maxYear) setCurrentYear((prev) => prev + 1);
  };

  /**
   * Diminui Ano
  */
  const decrementYear = () => {
    if (currentYear > minYear) setCurrentYear((prev) => prev - 1);
  };

  /**
   * Logica para desabilitar meses invalidos
   * @param {*} month Mes de referencia
  */
  const isMonthDisabled = (month) => {
    const currentMonthNumber = parseInt(month);
    const startMonth = 7;
    // Desabilita meses antes de julho de 2017
    if (currentYear === minYear && currentMonthNumber < startMonth) {
      return true;
    }

    //Desabilita meses que nao possuem mosaico
    if (limitYear && limitMonth) {
      if (currentYear > limitYear) return true;
      if (currentYear === limitYear && currentMonthNumber > limitMonth) return true;
    }

    // Desabilita todos os meses dps do mes inicial
    if (currentYear > previousYear || (currentYear === previousYear && currentMonthNumber > previousMonth)) {
      return true;
    }

    return false;
  };

  /**
   * Função responsavel por verificar se o mosaico ja esta disponivel ou nao.
   * @param {*} year Lado de referencia
   * @param {*} month Mes de referencia
  */
  const checkBasemapAvailability = async (year, month) => {
    setIsLoading(true)
    // Chama service que busca api da sccon se o mosaico referente(mes/ano atual) existe na base de dados deles
    const result = await checkMosaicSCCON(year, month)
    setIsLoading(false)
    if (result) {
      if(result.month === '12' || result.month === 12) {
        decrementYear()
      }
      setSelectedYear(result.year)
      setSelectedMonth(result.month)
      setLimitYear(parseInt(result.year))
      setLimitMonth(parseInt(result.month))
    }
  };

  // Chama a função de ativação
  useEffect(() => {
    // Na primeira renderização, verifica se o mosaico de referencia atual esta disponivel
    if (count === 0) {
      checkBasemapAvailability(selectedYear, selectedMonth)
      setCount((prevCount) => prevCount + 1);
    }

    // Busca o mapa base da sccon
    activeModule.basemaps.forEach((item) => {
      if (item.link.includes('sccon')) {
        setBaseMapSCCON(item)
        // Se estiver ativo, executa as funcoes para atualizar o mapabase 
        if (item.active === true) {
          changeBaseMapDinamic(item.id, updateLink(item.link, selectedYear, selectedMonth));
          changeAttributionDinamic(dateAttribution);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeModule, changeAttributionDinamic, changeBaseMapDinamic, dateAttribution, selectedMonth, selectedYear, count]);

  useEffect(() => {
    if (isActive) {
      changeAttributionDinamic(dateAttribution)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, isActive])

  return (
    <>
      <ButtonTooltip
        tooltip={ChangeMosaic.properties.alias}
        description={ChangeMosaic.properties.description}
        onClick={() => {
          setCurrentYear(selectedYear);
          setIsActive();
        }}
        active={isActive}
      >
        <Icon i="map-timeline" width="18" height="18" style={{ verticalAlign: 'middle' }} />
      </ButtonTooltip>
      {isActive && (
        <CustomDraggable>
          <WrapModal>
            <div className="divIcon"><DragIndicatorIcon /></div>
            {!isLoading ? (
              <>
                <div className="divYear">
                  <button onClick={decrementYear} disabled={currentYear <= minYear}>{'<'}</button>
                  <span className="spanYear">{currentYear}</span>
                  <button onClick={incrementYear} disabled={currentYear >= maxYear}>{'>'}</button>
                </div>
                <div className="divMonths">
                  {months.map((month) => (
                    <button
                      key={month.number}
                      disabled={isMonthDisabled(month.number)}
                      onClick={() => handleMonthClick(month.number)}
                      className={
                        selectedMonth === month.number && selectedYear === currentYear
                          ? 'selected'
                          : ''
                      }
                    >
                      {month.name}
                    </button>
                  ))}
                </div>
                <div className="divMosaicCurrent">
                  {selectedMonth && selectedYear ? (
                    <span>
                      Mosaico Atual: {months.find((m) => m.number === selectedMonth)?.name} de {selectedYear}
                    </span>
                  ) : (
                    <span>Nenhum mosaico selecionado</span>
                  )}
                </div>
              </>
            ) : (
              <div className="divLoading">
                <CircularProgress size="2rem" />
              </div>
            )}
          </WrapModal>
        </CustomDraggable>
      )}
    </>
  );
};

ChangeMosaic.properties = {
  id: 'CPN-TB-RA-CHANGE-MOSAIC',
  alias: 'Alterar Mosaicos',
  description: 'Realiza a alteração dos mosaicos da Planet.',
};

export default ChangeMosaic;
